module.exports = __webpack_public_path__ + "ipanemaclube.jpg?622e5f147213331a796d1a48c8024f34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/ipanemaclube.jpg
// module id = 126
// module chunks = 0